export default {"src":"https://cdn.dnse.com.vn/dnse-recruitment/_next/static/media/icon-fb.5d830836.svg","height":32,"width":32};